import { Injectable, inject } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { LuxonDateAdapter } from '@angular/material-luxon-adapter';
import { DateTime } from 'luxon';
import { UserService } from 'taxtank-core';

@Injectable()
export class ZonedDateAdapter extends LuxonDateAdapter implements DateAdapter<DateTime> {
  private userService = inject(UserService);

  timezone = this.userService.getCacheFirst()?.clientDetails?.timezone;

  constructor() {
    // v22: LuxonDateAdapter injects MAT_DATE_LOCALE and adapter options internally
    super();
  }

  override format(date: DateTime, displayFormat: string): string {
    if (this.timezone) {
      date = date.setZone(this.timezone);
    }

    return super.format(date, displayFormat);
  }
}
